import { render, staticRenderFns } from "./CombustivelSelect.vue?vue&type=template&id=7cfd580a&"
import script from "./CombustivelSelect.vue?vue&type=script&lang=js&"
export * from "./CombustivelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports